// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_int32 from "rescript/lib/es6/caml_int32.js";
import * as PlTimeChart from "./PlTimeChart.bs.js";
import * as PlGamesChart from "./PlGamesChart.bs.js";
import * as PlTimeChart2 from "./PlTimeChart2.bs.js";
import * as Caml_splice_call from "rescript/lib/es6/caml_splice_call.js";

function PlLpChart$Placeholder(Props) {
  var chartWidth = Props.chartWidth;
  var chartHeight = Props.chartHeight;
  return React.createElement("div", {
              className: CssJs.merge([
                    "flex items-center justify-center",
                    CssJs.style([
                          CssJs.width(CssJs.px((chartWidth + 46 | 0) + 10 | 0)),
                          CssJs.height(CssJs.px(chartHeight + 51 | 0))
                        ])
                  ])
            }, React.createElement("div", {
                  className: "text-xl text-white2 font-montserrat font-medium"
                }, "No LP data"));
}

var Placeholder = {
  make: PlLpChart$Placeholder
};

function PlLpChart(Props) {
  var masterRanks = Props.masterRanks;
  var region = Props.region;
  var matches = Props.matches;
  var onShowDetails = Props.onShowDetails;
  var chartWidth = Props.chartWidth;
  var chartHeight = Props.chartHeight;
  var queueId = Props.queueId;
  var rankHistory = Props.rankHistory;
  var forceTimeChart = Props.forceTimeChart;
  var match = React.useState(function () {
        return false;
      });
  var setInit = match[1];
  React.useEffect((function () {
          Curry._1(setInit, (function (param) {
                  return true;
                }));
          
        }), []);
  var tmp;
  if (match[0]) {
    if (queueId === 1130) {
      var firstMatch = Caml_splice_call.spliceApply(Math.min, [Belt_Array.map(matches, (function (mi) {
                    return mi.dateTime;
                  }))]) - 60 * 1000;
      tmp = React.createElement(PlTimeChart2.make, {
            region: region,
            onShowDetails: onShowDetails,
            padLeft: 46,
            chartWidth: chartWidth,
            chartHeight: chartHeight,
            rankHistory: rankHistory,
            masterRanks: masterRanks,
            firstMatch: firstMatch
          });
    } else {
      tmp = forceTimeChart || Caml_int32.div(chartWidth, matches.length) <= 5 ? React.createElement(PlTimeChart.make, {
              region: region,
              matches: matches,
              onShowDetails: onShowDetails,
              padLeft: 46,
              chartWidth: chartWidth,
              chartHeight: chartHeight,
              masterRanks: masterRanks
            }) : React.createElement(PlGamesChart.make, {
              region: region,
              matches: matches,
              onShowDetails: onShowDetails,
              padLeft: 46,
              chartWidth: chartWidth,
              chartHeight: chartHeight,
              masterRanks: masterRanks,
              isDuo: queueId === 1160
            });
    }
  } else {
    tmp = null;
  }
  return React.createElement("div", {
              className: "ml-[-12px] mr-[-4px] max-w-[100vw] overflow-x-clip mt-[-10px]"
            }, React.createElement("div", {
                  className: CssJs.merge([
                        "relative",
                        CssJs.style([
                              CssJs.width(CssJs.px((chartWidth + 46 | 0) + 10 | 0)),
                              CssJs.height(CssJs.px(chartHeight + 51 | 0))
                            ])
                      ])
                }, tmp));
}

var padLeft = 46;

var make = PlLpChart;

export {
  padLeft ,
  Placeholder ,
  make ,
  
}
/* CssJs Not a pure module */
